import { FC } from "react"
import './proveedoresentradaskpi.css'
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io"
import { isNanParseFloatTreatment, numberFormatter } from "../../../../../utils/helperFunctions"

export const ProveedoresEntradasKPI:FC<any> = (props):JSX.Element => {

    const { title, valueA, valueB, comparativa ,filtered} = props

   

    if(comparativa) {
        return(
            <div className="proveedoresentradas-kpi-wrapper-comp" >
                <span >
                    <span style={{color:'var(--lis-dark)'}}>{ numberFormatter(valueA) } {isNanParseFloatTreatment(parseFloat(valueA)) > isNanParseFloatTreatment(parseFloat(valueB)) ? <IoMdArrowDropup style={{color:'green',minWidth:20}} size={16} /> : isNanParseFloatTreatment(parseFloat(valueB)) > isNanParseFloatTreatment(parseFloat(valueA))? <IoMdArrowDropdown style={{color:'red',minWidth:20}} size={16} /> : <span style={{color:'gray'}}>-</span>}</span>
                      <span>|</span>  
                     <span style={{color:'var(--lis-alternative)'}}> { numberFormatter(valueB) } {isNanParseFloatTreatment(parseFloat(valueA)) < isNanParseFloatTreatment(parseFloat(valueB)) ? <IoMdArrowDropup style={{color:'green',minWidth:20}} size={16} /> : isNanParseFloatTreatment(parseFloat(valueB)) < isNanParseFloatTreatment(parseFloat(valueA))? <IoMdArrowDropdown style={{color:'red',minWidth:20}} size={16} /> : <span style={{color:'gray'}}>-</span>}</span>
                     </span>
                <span >{ title }{ title === 'Contratado (Tm)' && filtered? <span style={{color:'red'}}>**</span> : false }</span>
            </div>
        )
    } else {
        return (
            <div className="proveedoresentradas-kpi-wrapper" >
                <span style={{color:'var(--lis-dark)'}}>{ numberFormatter(valueA) }</span>
                <span >{ title }{ title === 'Contratado (Tm)' && filtered? <span style={{color:'red'}}>**</span> : false }</span>
            </div>
        )
    }

}